import type { FaireProductEntity } from "../../entity_types/product";

export const p_f9pv4qrhy4: FaireProductEntity = {
  token: "p_f9pv4qrhy4",
  type: "product",
  name: "Pink Mahjong Scorecard Notepad 6x9",
  brandToken: "b_as93nxevgz",
  brandName: "Rachel Brooks Design, LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/e96cd77eed4bef0e58b94744d3c9d5438327979095ffeaf4cec4cd95bb276ccc.webp",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    'Pink Mahjong Scorecard Notepad\n\n• Size 6"x9"\n• Gummed pages\n• Aprox. 100 Sheets of 100lb text',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:49.724Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
